<template lang="pug">
  LayoutDefault
    .page: .container-fluid
      .section: .card: .card--body
        .heading--section Trading Ledgers
        
        Loading(:isLoading="isDataLoading", type="bar")
          DataTable.mt-4(
            :records="contracts", 
            :headers="headers", 
            :itemsPerPageOptions="[50, 75, 100, 150, 200]",
            :emptyDisplayMessage="`No records found. You currently do not have any Trading Ledgers.`",
          )

</template>



<script>
import requestHandlers from '../../mixins/requestHandlers';

import DataTable from '../../components/DataTable';
import Loading from '../../components/Loading';

export default {
  name: 'tradesContracts',
  mixins: [requestHandlers],
  components: {
    DataTable,
    Loading
  },

  data() {
    return {
    	contracts: [],
      headers: [
        {
          id: 'date',
          text: 'Date',
          sortable: true,
          type: 'string',
          colWidth: 10,
        },
        {
          id: 'counter',
          text: 'Counter',
          sortable: true,
          type: 'counter',
          colWidth: 10,
        },
        {
          id: 'type',
          text: 'Type',
          type: 'string',
          colWidth: 5,
          colAlignment: 'center',
        },
        {
          id: 'currency',
          text: 'Currency',
          type: 'string',
          colWidth: 6,
          colAlignment: 'center',
        },
        {
          id: 'quantity',
          text: 'Quantity',
          sortable: true,
          type: 'number',
          filter: 'round',
          colWidth: 8,
          colAlignment: 'center',
        },
        {
          id: 'unitPrice',
          text: 'Price',
          sortable: true,
          type: 'number',
          filter: 'decimal',
          colWidth: 6,
          colAlignment: 'center',
        },
        {
          id: 'value',
          text: 'Contract Value',
          sortable: true,
          type: 'number',
          filter: 'twoDecimal',
          colWidth: 10,
          colAlignment: 'center',
        },
        {
          id: 'netAmount',
          text: 'Net Amount (MYR)',
          sortable: true,
          type: 'number',
          filter: 'twoDecimal',
          colWidth: 12,
          colAlignment: 'center',
        },
      ],
    }
  },

  computed: {
  },

  methods: {
    FETCH_RECORDS() {
      this.REQUEST_INIT();
      this.$axios.get('/Trades/Contracts')
      .then(response => {
        if(response.status === 200) {
          this.contracts = response.data.data;
        }
      })
      .catch(error => this.HANDLE_ERROR_GENERIC(error))
      .then(response => this.REQUEST_FINALLY());
    }
  },

  created() {
    this.FETCH_RECORDS();
  },
}

</script>




<style lang="scss">
	
</style>
